var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.325 5.25C22.5 5.625 21.6 5.7 20.7 5.85C21.525 5.25 21.975 5.025 22.575 3.75C21.675 4.275 20.85 4.2 19.8 4.425C18.975 3.525 17.775 3 16.425 3C13.875 3 11.775 5.025 11.775 7.575C11.775 7.95 11.85 8.25 11.925 8.625C8.10001 8.4 4.65 6.525 2.325 3.825C1.95 4.5 1.80001 5.325 1.80001 6.225C1.80001 7.8 2.625 9.225 3.825 9.975C3.075 9.975 2.325 9.75 1.725 9.375V9.45C1.725 11.625 3.30001 13.5 5.40001 13.875C5.02501 13.95 4.575 14.025 4.2 14.025C3.9 14.025 3.60001 14.025 3.30001 13.95C3.90001 15.75 5.475 17.25 7.5 17.25C5.55 19.5 1.125 18.825 0.75 18.75C2.775 20.025 5.25001 21 7.80001 21C16.275 21 20.925 14.1 20.925 8.1C20.925 7.875 20.925 7.725 20.925 7.5C21.975 6.825 22.725 6.15 23.325 5.25Z","fill":"#1E222D"}));
}

TwitterInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
